import React from 'react'
import { Link } from 'react-router-dom'
import Errorimg from '../assets/img/error.svg'


class Error extends React.Component {
    componentDidMount() {
        document.title = this.props.title;
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <div className="py-5 my-5 container error">
                <img src={Errorimg} className="img-fluid mb-4" />
                <p className="display-4 text-center font-weight-bold cd-red-text">Sorry, Page Not Found</p>
                <p className="text-center font-weight-bold cd-blue-text">The requested page is not available.</p>
                <div className="text-center">
                <Link to="/">
                    <button className="btn btn-danger m-0 cd-depth cd-pill"><i class="fas fa-home mr-2"></i>Back To Home</button>
                </Link>
                </div>
            </div>
        )
    }
}

export default Error;